import { Breadcrumbs, Container } from "@storoey/sui";
import { useNavigate } from "@tanstack/solid-router";
import { For } from "solid-js";

export const SectionBreadcrumbs = (props: {
  items: { title: string; path?: string }[];
}) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Breadcrumbs>
        <For each={props.items}>
          {(item, index) => {
            const current = index() === props.items.length - 1;

            if (item.path) {
              return (
                <Breadcrumbs.Item
                  onClick={() => navigate({ to: item.path })}
                  current={current}
                >
                  {item.title}
                </Breadcrumbs.Item>
              );
            }

            return (
              <Breadcrumbs.Item current={current}>
                {item.title}
              </Breadcrumbs.Item>
            );
          }}
        </For>
      </Breadcrumbs>
    </Container>
  );
};
